// Biodata wajib peserta -- cermin BIODATA_WAJIB di server.py (urutan = urutan tampil).
// Nilai filter Daftar Peserta (?biodata=...) = parameter backend biodata_kosong.
export const BIODATA_WAJIB = [
    { key: "tempat_lahir", label: "Tempat Lahir" },
    { key: "tanggal_lahir", label: "Tanggal Lahir" },
    { key: "no_hp", label: "No. HP" },
    { key: "alamat", label: "Alamat" },
];
// Penanda "Biodata wajib belum lengkap" (kartu Dashboard & filter) = 4 isian di atas + NIK &
// Email -- cermin BIODATA_PENANDA di server.py (sejak impor biodata longgar, Okt 2026).
export const BIODATA_PENANDA = [
    ...BIODATA_WAJIB,
    { key: "nik", label: "NIK" },
    { key: "email", label: "Email" },
];
export const FILTER_BIODATA_SEMUA = "semua";
export const FILTER_BIODATA_IDENTITAS = "identitas"; // NIK atau Email kosong
export const FILTER_BIODATA_NILAI = [FILTER_BIODATA_SEMUA, FILTER_BIODATA_IDENTITAS, ...BIODATA_PENANDA.map((b) => b.key)];

// Rincian per field utk kartu "Perlu dilengkapi": hanya field yg kosongnya > 0, urutan tetap.
export function rincianBiodataKurang(perField) {
    return BIODATA_PENANDA
        .map((b) => ({ ...b, jumlah: Number(perField?.[b.key]) || 0 }))
        .filter((b) => b.jumlah > 0);
}
